import { BrandColors, Colors } from "@/constants/theme";
import { useColorScheme } from "@/hooks/use-color-scheme";
import Ionicons from "@react-native-vector-icons/ionicons";
import React from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";
import { ThemedText } from "../themed-text";
import { Label } from "./label";

interface DropdownTriggerProps {
  label: string;
  value?: string;
  placeholder: string;
  onPress: () => void;
  hasError?: boolean;
}

export function DropdownTrigger({
  label,
  value,
  placeholder,
  onPress,
  hasError,
}: DropdownTriggerProps) {
  const colorScheme = useColorScheme();
  const theme = Colors[colorScheme ?? "light"];
  const triggerTestId = `dropdown-${label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "")}`;

  return (
    <TouchableOpacity
      testID={triggerTestId}
      accessible
      accessibilityLabel={`${label}, ${value ?? placeholder}`}
      style={[
        styles.selector,
        hasError && styles.inputError,
        { backgroundColor: theme.background, borderColor: theme.border },
      ]}
      onPress={onPress}
      activeOpacity={0.85}
    >
      <View style={{ flex: 1 }}>
        <Label label={label} />
        <ThemedText
          style={[styles.selectorValue, !value && styles.selectorPlaceholder]}
          numberOfLines={1}
        >
          {value ?? placeholder}
        </ThemedText>
      </View>
      <Ionicons name="chevron-down" size={18} color={BrandColors.mediumGray} />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  selector: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderWidth: 1,
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 12,
    minHeight: 55,
  },
  selectorValue: {
    fontSize: 15,
    fontWeight: "600",
    color: BrandColors.mediumGray,
    marginTop: 2,
  },
  selectorPlaceholder: {
    color: BrandColors.mediumGray,
    fontWeight: "400",
  },
  inputError: {
    borderColor: BrandColors.error,
    borderWidth: 1,
  },
});
